export const logoWithoutBeta = `<svg width="642" height="192" viewBox="0 0 642 192" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6429_56034)">
<mask id="mask0_6429_56034" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="3" width="189" height="189">
<path d="M0 3.72144H188.445V192H0V3.72144Z" fill="white"/>
</mask>
<g mask="url(#mask0_6429_56034)">
<path d="M125.607 3.76514L52.7185 82.0161V3.76514H0V192H52.7185V144.941L72.6209 123.698L126.414 192H188.276L107.318 87.1259L184.241 3.76514" fill="white"/>
</g>
<mask id="mask1_6429_56034" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="220" y="3" width="118" height="189">
<path d="M220.086 3.72144H337.341V192H220.086V3.72144Z" fill="white"/>
</mask>
<g mask="url(#mask1_6429_56034)">
<path d="M220.414 3.76514H273.669V149.782H336.976V192H220.414" fill="white"/>
</g>
<mask id="mask2_6429_56034" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="375" y="48" width="55" height="145">
<path d="M375.961 48.3804H429.47V192H375.961V48.3804Z" fill="white"/>
</mask>
<g mask="url(#mask2_6429_56034)">
<path d="M376.104 192H429.358V48.4568H376.104V192Z" fill="#FF8AFF"/>
</g>
<mask id="mask3_6429_56034" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="463" y="3" width="179" height="189">
<path d="M463.902 3.72144H641.646V192H463.902V3.72144Z" fill="white"/>
</mask>
<g mask="url(#mask3_6429_56034)">
<path d="M512.428 179.978C497.339 171.96 485.488 160.801 476.866 146.491C468.243 132.186 463.938 115.983 463.938 97.8818C463.938 79.7828 468.243 63.5827 476.866 49.2725C485.488 34.9659 497.339 23.8049 512.428 15.7875C527.514 7.77381 544.539 3.76514 563.509 3.76514C580.06 3.76514 594.968 6.69805 608.247 12.5566C621.522 18.4188 632.559 26.8668 641.354 37.8952L608.763 67.3715C597.038 53.2394 582.814 46.1688 566.092 46.1688C556.264 46.1688 547.513 48.3276 539.845 52.6343C532.167 56.9446 526.22 63.0212 522 70.8623C517.77 78.707 515.662 87.7129 515.662 97.8818C515.662 108.054 517.77 117.06 522 124.903C526.22 132.748 532.167 138.824 539.845 143.131C547.513 147.441 556.264 149.597 566.092 149.597C582.814 149.597 597.038 142.528 608.763 128.392L641.354 157.868C632.559 168.904 621.522 177.35 608.247 183.209C594.968 189.067 580.06 192 563.509 192C544.539 192 527.514 187.992 512.428 179.978Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_6429_56034">
<rect width="642" height="192" fill="white"/>
</clipPath>
</defs>
</svg>
`;
